import axios from 'axios';

const apiManager = axios.create({
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
apiManager.interceptors.request.use(
  (config) => {
    // Add any default headers or request modifications here
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
apiManager.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle errors globally if needed
    console.error('API Error:', error);
    return Promise.reject(error);
  }
);

export default apiManager;
